import styled from 'styled-components';
import { half } from 'ui/theme/spacing';

import { Search } from './Search';
import { Dropdown } from './Dropdown';
import { ClearFiltersButton } from './ClearFiltersButton';
import { NewFolderButton } from '../NewFolderButton';

const Wrapper = styled.div`
  display: flex;
  gap: ${half};
  align-items: center;
`;

export const SecondaryFilters = () => (
  <Wrapper data-test="secondary-filters">
    <NewFolderButton />
    <ClearFiltersButton />
    <Dropdown />
    <Search />
  </Wrapper>
);
